class GtmUtils {
    convertToGtmEecProduct(trackableProduct, additionalFields) {
        let gtmProduct = null;

        if (trackableProduct) {
            if (!trackableProduct.productNo || !trackableProduct.name) {
                console.error('[GTM]: Failed to push product with ID#' + (trackableProduct.productId || 'UNKNOWN') + ' to dataLayer. Reason: productno and name are both required.');
            } else {
                gtmProduct = { 'id': trackableProduct.productNo, 'name': trackableProduct.name };

                if (trackableProduct.price) {
                    gtmProduct['price'] = trackableProduct.price;
                }
                if (trackableProduct.parentProductNo) {
                    gtmProduct['dimension1'] = trackableProduct.parentProductNo;
                }
                if (trackableProduct.brand) {
                    gtmProduct['brand'] = trackableProduct.brand;
                }
                if (trackableProduct.variants && trackableProduct.variants.length > 0) {
                    gtmProduct['variant'] = trackableProduct.variants.join(' ');
                }

                if (additionalFields) {
                    gtmProduct = { ...gtmProduct, ...additionalFields };
                }
            }
        }

        return gtmProduct;
    }

    convertToGtmGa4Product(trackableProduct, additionalFields) {
        let gtmProduct = null;

        if (trackableProduct) {
            if (!trackableProduct.productNo || !trackableProduct.name) {
                console.error('[GTM]: Failed to push product with ID#' + (trackableProduct.productId || 'UNKNOWN') + ' to dataLayer. Reason: productno and name are both required.');
            } else {
                gtmProduct = { 'item_id': trackableProduct.productNo, 'item_name': trackableProduct.name };

                if (trackableProduct.sellPrice) {
                    gtmProduct['price'] = trackableProduct.sellPrice;
                }

                if (trackableProduct.discountPrice) {
                    gtmProduct['discount'] = trackableProduct.discountPrice;
                }

                if (trackableProduct.parentProductNo) {
                    gtmProduct['dimension1'] = trackableProduct.parentProductNo;
                }
                if (trackableProduct.brand) {
                    gtmProduct['item_brand'] = trackableProduct.brand;
                }
                if (trackableProduct.variants && trackableProduct.variants.length > 0) {
                    gtmProduct['item_variant'] = trackableProduct.variants.join(' ');
                }
                if (trackableProduct.categories) {
                    for (let i = 0; i < trackableProduct.categories.length; i++) {
                        if (i > 0) {
                            gtmProduct['item_category' + (i + 1)] = trackableProduct.categories[i];
                        } else {
                            gtmProduct['item_category'] = trackableProduct.categories[i];
                        }
                    }
                }

                if (additionalFields) {
                    gtmProduct = { ...gtmProduct, ...additionalFields };
                }
            }
        }

        return gtmProduct;
    }

    getCurrencyCode(inputData) {
        let currencyCode;
        if (inputData && inputData.currencyCode) {
            currencyCode = inputData.currencyCode;
        }
        else if (window.globalSettings && window.globalSettings.siteCurrencyCode) {
            currencyCode = window.globalSettings.siteCurrencyCode;
        } else {
            currencyCode = 'NOK';
        }

        return currencyCode;
    }

    hasMarketingConsent(win) {
        const cookieString = "; " + win.document.cookie;
        const parts = cookieString.split("; cookie-consent-marketing=");
        return parts.length === 2 && parts.pop().split(";").shift() === "1";
    }
}